/** Bayrak: Unicode bölgesel gösterge çiftleri (ISO 3166-1 alpha-2) */
export function flagEmoji(iso2) {
    if (!iso2 || iso2.length !== 2) return "";
    const A = 0x1f1e6;
    return [...iso2.toUpperCase()]
        .map((c) => String.fromCodePoint(A + (c.charCodeAt(0) - 65)))
        .join("");
}

/**
 * value: backend countryCode ile uyumlu (örn. +90)
 * Sık kullanılan ülkeler + Türkiye önde
 */
export const COUNTRY_DIAL_CODES = [
    { value: "+90", iso2: "TR", name: "Türkiye" },
    { value: "+1", iso2: "US", name: "ABD / Kanada" },
    { value: "+44", iso2: "GB", name: "Birleşik Krallık" },
    { value: "+49", iso2: "DE", name: "Almanya" },
    { value: "+33", iso2: "FR", name: "Fransa" },
    { value: "+39", iso2: "IT", name: "İtalya" },
    { value: "+31", iso2: "NL", name: "Hollanda" },
    { value: "+32", iso2: "BE", name: "Belçika" },
    { value: "+43", iso2: "AT", name: "Avusturya" },
    { value: "+41", iso2: "CH", name: "İsviçre" },
    { value: "+46", iso2: "SE", name: "İsveç" },
    { value: "+47", iso2: "NO", name: "Norveç" },
    { value: "+45", iso2: "DK", name: "Danimarka" },
    { value: "+358", iso2: "FI", name: "Finlandiya" },
    { value: "+34", iso2: "ES", name: "İspanya" },
    { value: "+351", iso2: "PT", name: "Portekiz" },
    { value: "+30", iso2: "GR", name: "Yunanistan" },
    { value: "+40", iso2: "RO", name: "Romanya" },
    { value: "+36", iso2: "HU", name: "Macaristan" },
    { value: "+48", iso2: "PL", name: "Polonya" },
    { value: "+420", iso2: "CZ", name: "Çekya" },
    { value: "+7", iso2: "RU", name: "Rusya / Kazakistan" },
    { value: "+380", iso2: "UA", name: "Ukrayna" },
    { value: "+994", iso2: "AZ", name: "Azerbaycan" },
    { value: "+374", iso2: "AM", name: "Ermenistan" },
    { value: "+995", iso2: "GE", name: "Gürcistan" },
    { value: "+964", iso2: "IQ", name: "Irak" },
    { value: "+98", iso2: "IR", name: "İran" },
    { value: "+966", iso2: "SA", name: "Suudi Arabistan" },
    { value: "+971", iso2: "AE", name: "BAE" },
    { value: "+20", iso2: "EG", name: "Mısır" },
    { value: "+212", iso2: "MA", name: "Fas" },
    { value: "+213", iso2: "DZ", name: "Cezayir" },
    { value: "+216", iso2: "TN", name: "Tunus" },
    { value: "+218", iso2: "LY", name: "Libya" },
    { value: "+91", iso2: "IN", name: "Hindistan" },
    { value: "+86", iso2: "CN", name: "Çin" },
    { value: "+81", iso2: "JP", name: "Japonya" },
    { value: "+82", iso2: "KR", name: "Güney Kore" },
    { value: "+61", iso2: "AU", name: "Avustralya" },
    { value: "+64", iso2: "NZ", name: "Yeni Zelanda" },
    { value: "+55", iso2: "BR", name: "Brezilya" },
    { value: "+52", iso2: "MX", name: "Meksika" },
    { value: "+54", iso2: "AR", name: "Arjantin" },
    { value: "+27", iso2: "ZA", name: "Güney Afrika" },
    { value: "+234", iso2: "NG", name: "Nijerya" },
];

export function dialOptionLabel({ value, iso2, name }) {
    const f = flagEmoji(iso2);
    return `${f} ${name} (${value})`;
}
